export default {
    data() {
        return {
            activeNames: ['1'],
            product: {},
            buyDialogShow: false,
            number: null,
            info: {},
            checked1: false,
            checked2: false,
            price: 0,
            isMarked: false,
            drawer: false,
            commentList: [],
            textarea: ''
        };
    },
    methods: {
        doCal(phone) {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }

            if (this.info.status === '待完善资料') {
                this.$hint.message.info(this.$t('请先完善个人资料'));
                return;
            }

            if (this.info.status === '待审核') {
                this.$hint.message.info(this.$t('请等待管理员审核通过'));
                return;
            }

            if (this.info.status === '审核未通过') {
                this.$hint.message.info(this.$t('审核未通过，请重新完善资料'));
                return;
            }

            const phoneNumber = phone;
            let message = this.$t('即将呼叫手机号') + "<span style='color: orange;font-size:15px'> [" +
              phoneNumber +
              "] </span>，" + this.$t('是否继续') + "？";
            this.$hint.confirm(message).then(res => {
                if (res) {
                    this.$http.incrPhoneCount(this.product.id).then(res => {
                        if (res.code === 200) {
                            window.location.href = `tel:${phoneNumber}`;
                        }
                    })

                }
            })
        },
        buy() {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }

            if (this.info.status === '待完善资料') {
                this.$hint.message.info(this.$t('请先完善个人资料'));
                return;
            }

            if (this.info.status === '待审核') {
                this.$hint.message.info(this.$t('请等待管理员审核通过'));
                return;
            }

            if (this.info.status === '审核未通过') {
                this.$hint.message.info(this.$t('审核未通过，请重新完善资料'));
                return;
            }

            this.buyDialogShow = true;
        },
        doBuy() {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }
            if (this.info.status === '已禁用') {
                this.$hint.message.info(this.$t('账号已被禁用'));
                return;
            }

            if (this.info.status === '待完善资料') {
                this.$hint.message.info(this.$t('请先完善个人资料'));
                return;
            }

            if (this.info.status === '待审核') {
                this.$hint.message.info(this.$t('请等待管理员审核通过'));
                return;
            }

            if (this.info.status === '审核未通过') {
                this.$hint.message.info(this.$t('审核未通过，请重新完善资料'));
                return;
            }

            if (!this.checked1) {
                this.$myAnime.shakeElement('.checked1',1)
                return;
            }

            if (!this.checked2) {
                this.$myAnime.shakeElement('.checked2',1)
                return;
            }

            if (this.$verify.checkIfNull(this.number)) {
                this.$myAnime.shakeElement('.number',1)
                return;
            }

            if (this.number > this.product.remain) {
                this.$hint.message.info(this.$t('超出库存余量'));
                return;
            }

            let createObj = {
                userId: this.info.id,
                username: this.info.account,
                companyName: this.info.companyName,
                productId: this.product.id,
                productName: this.product.title,
                productPic: this.product.pic,
                productDanwei: this.product.danwei,
                number: this.number,
                danjia: this.$verify.checkIfNull(this.product.gudingjia) ? null : this.product.gudingjia,
                jine: this.$verify.checkIfNull(this.product.gudingjia) ? null : this.price,
                jiesuanbizhong: (this.product.jiageleixing.includes('美元') ? '美元' : '人民币'),
                beizhu: '',
                hetongfujian: '',
                status: '定金待缴纳',
            }

            this.$http.createOrderBill(createObj).then(res => {
                if (res.code === 200) {
                    this.buyDialogShow = false;
                    this.$router.push('/Index/orderBill');
                }
            })
        },
        getUserInfo() {
            if (this.$store.state.currentUser !== null) {
                this.$http.getUserInfo().then(res => {
                    this.info = res.data;
                })
            }
        },
        numberInput(num) {
            this.price = this.product.gudingjia * num;
        },

        mark() {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }

            if (!this.isMarked) {
                let mark = {
                    userId: this.$store.state.currentUser.id,
                    businessId: this.product.id,
                    type: 'product'
                }
                this.$http.createMark(mark).then(res => {
                    if (res.code === 200) {
                        this.isMarked = true;
                    }
                })
            }else {
                this.$http.deleteMarkByUser(this.$store.state.currentUser.id,this.product.id,'product').then(res => {
                    if (res.code === 200) {
                        this.isMarked = false;
                    }
                })
            }
        },
        openComment() {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }
            this.drawer = true;
            this.$http.viewCommentTable(null,this.product.id,'product',null).then(res => {
                this.commentList = res.data;
            })
        },
        send() {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }
            if (this.info.status === '已禁用') {
                this.$hint.message.info(this.$t('账号已被禁用'));
                return;
            }
            if (this.info.status === '待完善资料') {
                this.$hint.message.info(this.$t('请先完善个人资料'));
                return;
            }

            if (this.info.status === '待审核') {
                this.$hint.message.info(this.$t('请等待管理员审核通过'));
                return;
            }

            if (this.info.status === '审核未通过') {
                this.$hint.message.info(this.$t('审核未通过，请重新完善资料'));
                return;
            }

            if (this.$verify.checkIfNull(this.textarea)) {
                this.$hint.message.info('说点什么吧');
                return;
            }
            let comment = {
                userId: this.$store.state.currentUser.id,
                phone: this.info.phone,
                businessId: this.product.id,
                content: this.textarea,
                type: 'product',
            }
            this.$http.createComment(comment).then(res => {
                if (res.code === 200) {
                    this.$http.viewCommentTable(null,this.product.id,'product',null).then(res => {
                        this.commentList = res.data;
                        this.textarea = '';
                    })
                }
            })
        },

        copy(value) {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }

            if (this.info.status === '待完善资料') {
                this.$hint.message.info(this.$t('请先完善个人资料'));
                return;
            }

            if (this.info.status === '待审核') {
                this.$hint.message.info(this.$t('请等待管理员审核通过'));
                return;
            }

            if (this.info.status === '审核未通过') {
                this.$hint.message.info(this.$t('审核未通过，请重新完善资料'));
                return;
            }
            // 检查浏览器是否支持Clipboard API
            if (navigator.clipboard) {
                const textToCopy = value;
                navigator.clipboard.writeText(textToCopy)
                  .then(() => {
                      this.$hint.message.info('已复制到剪切板');
                  })
                  .catch(err => {
                      console.error("复制到剪切板时出错：", err);
                  });
            } else {
                this.$hint.message.info('浏览器不支持复制');
            }
        },

    },
    created() {

    },
    mounted() {
        console.log('执行')
        let id = this.$route.params.data;
        this.$http.viewProductById(id).then(res => {
            if (res.code === 200) {
                this.product = res.data;
                console.log(this.product);
            }
        })

        // 查关注
        if (this.$store.state.currentUser !== null) {
            this.$http.viewMarkTable(this.$store.state.currentUser.id,id,'product').then(res => {
                if (res.data.length > 0) {
                    this.isMarked = true;
                }
            })
        }

        this.getUserInfo();
    }
}